import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const LayersIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="layers" ref={ref} {...props}>
      <path d="M12,17.42a.85.85,0,0,1-.35-.08L2.71,12.7a.75.75,0,0,1,.69-1.33L12,15.83l8.6-4.46a.75.75,0,1,1,.69,1.33l-8.95,4.64A.77.77,0,0,1,12,17.42Zm.34-4.25,9-4.64a.75.75,0,0,0,0-1.33l-9-4.77a.73.73,0,0,0-.7,0L2.7,7.2a.75.75,0,0,0,0,1.33l8.94,4.64a.85.85,0,0,0,.35.08A.77.77,0,0,0,12.34,13.17ZM12,3.94l7.34,3.92L12,11.66,4.66,7.86Zm.34,17.64,9-4.64a.75.75,0,1,0-.69-1.33L12,20.07,3.4,15.61a.75.75,0,1,0-.69,1.33l8.94,4.64a.85.85,0,0,0,.35.08A.77.77,0,0,0,12.34,21.58Z" />
    </Icon>
  ),
) as IconWithRender;

LayersIcon.displayName = 'LayersIcon';
LayersIcon.renderIcon = (props) => <LayersIcon {...props} />;
export default LayersIcon;
